var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('mm-loading',{model:{value:(_vm.mmLoadShow),callback:function ($$v) {_vm.mmLoadShow=$$v},expression:"mmLoadShow"}}),_c('music-list',{attrs:{"list":_vm.list},on:{"select":_vm.selectItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }